export default __webpack_public_path__ + "static/media/frontView.c0b79f00.jpg";